import * as universal from "../../../src/routes/document/[doc_type]/[doc_id]/+page.js";
export { universal };
export { default as component } from "../../../src/routes/document/[doc_type]/[doc_id]/+page.svelte";
export const has_server_load = true;